import { metadata } from '@atlaskit/object/metadata';

import { getObjectName } from './get-object-name';
import { type ObjectTileData } from './types';

let objectTilesPromise: Promise<Record<string, ObjectTileData> | undefined> | null = null;

// get object tile info as a Promise which returns a Record
export const getObjectTiles: () => Promise<Record<string, ObjectTileData> | undefined> = () => {
	if (!objectTilesPromise) {
		objectTilesPromise = Promise.all(
			Object.entries(metadata).map(async ([name, meta]) => {
				const objectTile = await meta.tile.packageLoader();
				return { name, objectTile: objectTile.default, meta };
			}),
		)
			.then((newData) =>
				newData
					.map((objectTile) => {
						return {
							[objectTile.name]: {
								keywords: [...objectTile.meta.keywords, 'tile'],
								component: objectTile.objectTile,
								componentName: objectTile.meta.tile.componentName,
								packageName: objectTile.meta.tile.package,
								objectName: getObjectName(objectTile.name),
								color: objectTile.meta.color,
								icon: objectTile.meta.icon,
								iconPackage: objectTile.meta.iconPackage,
							} as ObjectTileData,
						};
					})
					.reduce((acc, b) => ({ ...acc, ...b })),
			)
			.catch(() => {
				return undefined;
			});
	}

	return objectTilesPromise;
};
